<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent>
    <v-card class="mx-auto">
      <v-card-title class="headline white--text modal-header-especialidade">
        Editar Paciente
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fecharModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
        </v-row>
        <soi-form-paciente-sem-layout
          :value="value"
          :componente="true"
          @pacienteSalvo="pacienteSalvo"
          ref="formPaciente">
        </soi-form-paciente-sem-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'soi-modal-paciente',

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            if (this.$refs.formPaciente) {
              this.$refs.formPaciente.paciente = { ...newValue };
            }
          });
        }
      },
    },
  },

  methods: {
    abrirModal() {
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.formPaciente) {
          this.$refs.formPaciente.paciente = { ...this.value };
        }
      });
    },

    fecharModal() {
      this.dialog = false;
    },

    pacienteSalvo() {
      this.$emit('paciente-salvo');
      this.fecharModal();
    },
  },
});
</script>

<style scoped>
.modal-header-especialidade {
  background: var(--especialidade-gradient, linear-gradient(135deg, #2e4b9d 0%, #4a6fa5 100%)) !important;
}
</style>
